import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ReportLogOfEvents } from '@report/models/report-of-event-log';
import { StaticMessage } from '@shared/enums';

@Component({
  selector: 'app-report-events-log-with-groups-and-activities',
  templateUrl: './report-events-log-with-groups-and-activities.component.html',
  styleUrls: ['./report-events-log-with-groups-and-activities.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportEventsLogWithGroupsAndActivitiesComponent {
  @Input({ required: true }) eventLogPrefix: string;
  @Input({ required: true }) reportLogOfEvent: ReportLogOfEvents;
  StaticMessage = StaticMessage;
}
